var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7001 7.05C20.0251 5.475 18.6001 4.5 16.8001 4.5C15.3001 4.5 14.1751 5.1 13.2751 6.225L12.0751 7.65L10.8751 6.225C9.90009 5.1 8.77509 4.5 7.27509 4.5C5.47509 4.5 4.05009 5.475 3.45009 7.05C2.77509 8.625 2.85009 11.025 4.57509 12.75L12.0751 20.25L19.5751 12.75C21.3001 11.025 21.3751 8.625 20.7001 7.05ZM12.0751 5.325C13.0501 4.05 14.5501 3 16.8001 3C22.5001 3 24.3751 10.05 20.5501 13.875L13.4019 21.0231C12.6252 21.7998 11.3705 21.8047 10.59 21.0318C8.88574 19.3442 5.93701 16.4117 3.45009 13.875C-0.29991 10.05 1.57509 3 7.27509 3C9.52509 3 11.0251 4.05 12.0751 5.325ZM17.3251 9C17.3251 9.41421 16.9893 9.75 16.5751 9.75C16.1609 9.75 15.8251 9.41421 15.8251 9C15.8251 8.58579 16.1609 8.25 16.5751 8.25C16.9893 8.25 17.3251 8.58579 17.3251 9Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/Favorite.d3d11381.svg";
export { ForwardRef as ReactComponent };